import { render, staticRenderFns } from "./OpenChannelWizard.vue?vue&type=template&id=01352a1d&"
import script from "./OpenChannelWizard.vue?vue&type=script&lang=js&"
export * from "./OpenChannelWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports